import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  orderInfoList: {
    margin: 0,
    padding: '20px 15px 0',
    color: theme.colors.light.lightCyan,
    fontSize: 12,
    listStyle: 'none',
  },
}));
